import { render } from "./ArtistVideoCard.vue?vue&type=template&id=47e70353"
import script from "./ArtistVideoCard.vue?vue&type=script&lang=js"
export * from "./ArtistVideoCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ArtistVideoCard.vue?vue&type=style&index=0&id=47e70353&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__